import React, { Component } from 'react';

import { DatePicker } from '@progress/kendo-react-dateinputs';
import CustomPopup from './CustomPopup';

class MonthYearPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null
    };
  }

  componentDidMount() {
    if (this.props.value) {
      const date = new Date(this.props.value);
      this.setState({
        value: date
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.value && this.props.value !== prevProps.value) {
      const date = new Date(this.props.value);
      this.setState({
        value: date
      });
    } else if (this.props.value === null && prevProps.value !== null) {
      this.setState({
        value: null
      });
    }
  }

  handleChange = event => {
    const date = event.value;
    this.setState({
      value: date
    });

    this.props.onChange({ value: date, name: this.props.name });
  };

  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <DatePicker
          calendar={props => <CustomPopup {...props} />}
          onChange={this.handleChange}
          value={this.state.value}
          required={this.props.required}
          width="100%"
          format={'MM/yyyy'}
          formatPlaceholder={{ month: 'MM', year: 'YYYY' }}
          disabled={this.props.disabled}
          min={this.props.min}
          max={this.props.max}
        />
      </div>
    );
  }
}

export default MonthYearPicker;
